import React, {Component} from 'react';
import Autosuggest, { ItemAdapter } from '../../modules/autosuggest/Autosuggest.js'
import Config from '../../config';

class AutoAdapter extends ItemAdapter {
 renderItem(item) {
  return (
   <div className="repo">
    <div>
     <div className="repo-title">{item.name} <small>{item.NID? item.NID:''}</small></div>
     <div className="repo-stats">
      <div>{item.address}, {item.locality}, {item.state}</div>
     </div>
    </div>
   </div>
  )
 }
}

AutoAdapter.instance = new AutoAdapter();

class ClientSearch extends Component {
 constructor(props) {
  super(props);

  this.doChange = this.doChange.bind(this);
  this.doSearch = this.doSearch.bind(this);
  this.doSelect = this.doSelect.bind(this);
  this.toggleModal = this.toggleModal.bind(this);

  this.state = {
   searchValue: '',
   searchResults: [],
   searchMessage: '',
   createClient: false
  }
 }

 doSearch(search) {
  if (search !== '') {
   const sp = search.lastIndexOf('/');
   if (sp >= 0) search = search.substring(sp + 1);

   this.setState({ searchMessage: 'Realizando busqueda...' });
   let url = '/api/clients/search?words=' + encodeURIComponent(search);
   this.props.reqAPI(Config.apiURI+url).then(searchResults => {
    let searchMessage

    if (searchResults.length === 0) {
     searchMessage = 'No existen resultados'
    }

    this.setState({ searchResults, searchMessage });
   }, err => {
    this.setState({
     searchResults: null,
     searchMessage: 'Se ha producido un error: ' + err.message
    })
   })
  } else {
   this.setState({
    searchResults: null,
    searchMessage: 'Escrbe al menos un carcater para comenzar la busqueda'
   });
  }
 }

 
 doChange(value) {
  this.setState({searchValue:value})
 }

 doSelect(client) {
  if(client !== null && client.ID !== undefined) {
   this.props.handleCallback(client);
   this.setState({
    searchValue: '',
    searchResults: [],
    searchMessage: ''
   });
  }
 }

 toggleModal() {
  this.setState({createClient:!this.state.createClient});
 }

 render() {
  return (
    <Autosuggest
     className={this.props.className}
     value={this.state.searchValue}
     showToggle={false}
     searchDebounce={500}
     allowDuplicates={false}
     closeOnCompletion={true}
     allowDuplicates={this.props.allowDuplicates}
     datalist={this.state.searchResults}
     datalistOnly={false}
     datalistPartial={false}
     datalistMessage={this.state.searchMessage}
     onDatalistMessageSelect={() => this.toggleModal()}
     itemReactKeyPropName="ID"
     itemValuePropName="name"
     placeholder={this.props.placeholder ? this.props.placeholder : "Asigna un cliente a este pedido"}
     onSearch={this.doSearch}
     onChange={this.doChange}
     onSelect={this.doSelect}
     itemAdapter={AutoAdapter.instance} />
  )
 }
}

export default ClientSearch;



// WEBPACK FOOTER //
// ./src/components/Client/Search.js